"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _recompose = require("recompose");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _Divider = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e17y25jx0"
})("height:0;", function (props) {
  return "\n    margin-top: ".concat(props.marginTop !== undefined ? props.marginTop : (0, _styledSystem.themeGet)('spacing.2')(props), "px;\n    margin-bottom: ").concat(props.marginBottom !== undefined ? props.marginBottom : (0, _styledSystem.themeGet)('spacing.2')(props), "px;\n    margin-left: ").concat(props.sideMargins, "px;\n    margin-right:  ").concat(props.sideMargins, "px;\n  ");
}, " border-bottom:1px solid ", (0, _styledSystem.themeGet)('colors.neutral.4'), ";user-select:none;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaXZpZGVyL2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU04QiIsImZpbGUiOiIuLi8uLi9zcmMvZGl2aWRlci9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNvbXBvc2UsIHNldERpc3BsYXlOYW1lLCBkZWZhdWx0UHJvcHMsIHNldFByb3BUeXBlcywgd2l0aFByb3BzIH0gZnJvbSAncmVjb21wb3NlJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB0aGVtZUdldCB9IGZyb20gJ3N0eWxlZC1zeXN0ZW0nO1xuaW1wb3J0IGMgZnJvbSAnY2xhc3NuYW1lcyc7XG5cbmNvbnN0IF9EaXZpZGVyID0gc3R5bGVkKCdkaXYnKWBcbiAgaGVpZ2h0OiAwO1xuICAke3Byb3BzID0+IGBcbiAgICBtYXJnaW4tdG9wOiAke3Byb3BzLm1hcmdpblRvcCAhPT0gdW5kZWZpbmVkID8gcHJvcHMubWFyZ2luVG9wIDogdGhlbWVHZXQoJ3NwYWNpbmcuMicpKHByb3BzKX1weDtcbiAgICBtYXJnaW4tYm90dG9tOiAke3Byb3BzLm1hcmdpbkJvdHRvbSAhPT0gdW5kZWZpbmVkID8gcHJvcHMubWFyZ2luQm90dG9tIDogdGhlbWVHZXQoJ3NwYWNpbmcuMicpKHByb3BzKX1weDtcbiAgICBtYXJnaW4tbGVmdDogJHtwcm9wcy5zaWRlTWFyZ2luc31weDtcbiAgICBtYXJnaW4tcmlnaHQ6ICAke3Byb3BzLnNpZGVNYXJnaW5zfXB4O1xuICBgfVxuICBib3JkZXItYm90dG9tOiAxcHggc29saWQgJHt0aGVtZUdldCgnY29sb3JzLm5ldXRyYWwuNCcpfTtcbiAgdXNlci1zZWxlY3Q6IG5vbmU7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBjb21wb3NlKFxuICBzZXRQcm9wVHlwZXMoe1xuICAgIG1hcmdpblRvcDogUHJvcFR5cGVzLm51bWJlcixcbiAgICBtYXJnaW5Cb3R0b206IFByb3BUeXBlcy5udW1iZXIsXG4gICAgc2lkZU1hcmdpbnM6IFByb3BUeXBlcy5udW1iZXJcbiAgfSksXG4gIGRlZmF1bHRQcm9wcyh7XG4gICAgc2lkZU1hcmdpbnM6IDBcbiAgfSksXG4gIHdpdGhQcm9wcyhwcm9wcyA9PiAoe1xuICAgIGNsYXNzTmFtZTogYygnZGl2aWRlcicsIHByb3BzLmNsYXNzTmFtZSlcbiAgfSkpLFxuICBzZXREaXNwbGF5TmFtZSgnRGl2aWRlcicpLFxuKShfRGl2aWRlcik7XG4iXX0= */"));

var _default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  marginTop: _propTypes.default.number,
  marginBottom: _propTypes.default.number,
  sideMargins: _propTypes.default.number
}), (0, _recompose.defaultProps)({
  sideMargins: 0
}), (0, _recompose.withProps)(function (props) {
  return {
    className: (0, _classnames.default)('divider', props.className)
  };
}), (0, _recompose.setDisplayName)('Divider'))(_Divider);

exports.default = _default;